export interface EConsentForm {
    id: string;
    templateName: string;
    description: string;
    documentPath: string;
    documentUrl: string;
    formName: string;
    formVersion: string;
    boldSignTemplateId: string;
    createdAt: string;
    updatedAt: string;
    status: 'inactive' | 'active';
    boldsignEditUrl: string;
}

export const econsentForms: EConsentForm[] = [
    {
        id: '1',
        templateName: 'General Consent Form',
        description: 'Standard consent form for general procedures',
        documentPath: '/documents/consent/general.pdf',
        documentUrl: 'https://example.com/documents/consent/general.pdf',
        formName: 'General Consent',
        formVersion: '1.0',
        boldSignTemplateId: '516e0ebb-8b0d-4795-85a3-3d03c4b4ce79e_ZZ3XuX2O',
        createdAt: '2024-01-15T10:00:00Z',
        updatedAt: '2024-01-15T10:00:00Z',
        status: 'active',
        boldsignEditUrl: 'https://app.boldsign.com/document/embed/?templateId=516e0ebb-8b0d-4795-85a3-3d03c4b4ce79e_ZZ3XuX2O;1c42ba9b-4a92-4a1c-affd-18414b422f4b&isEditTemplate=true'
    },
    {
        id: '2',
        templateName: 'Surgical Consent Form',
        description: 'Consent form for surgical procedures',
        documentPath: '/documents/consent/surgical.pdf',
        documentUrl: 'https://example.com/documents/consent/surgical.pdf',
        formName: 'Surgical Consent',
        formVersion: '2.1',
        boldSignTemplateId: '516e0ebb-8b0d-4795-85a3-3d03c4b4ce79e_ZZ3XuX2O',
        createdAt: '2024-01-16T14:30:00Z',
        updatedAt: '2024-01-16T14:30:00Z',
        status: 'active',
        boldsignEditUrl: 'https://app.boldsign.com/document/embed/?templateId=516e0ebb-8b0d-4795-85a3-3d03c4b4ce79e_ZZ3XuX2O;1c42ba9b-4a92-4a1c-affd-18414b422f4b&isEditTemplate=true'
    },
    {
        id: '3',
        templateName: 'Research Consent Form',
        description: 'Consent form for research participation',
        documentPath: '/documents/consent/research.pdf',
        documentUrl: 'https://example.com/documents/consent/research.pdf',
        formName: 'Research Consent',
        formVersion: '1.2',
        boldSignTemplateId: '516e0ebb-8b0d-4795-85a3-3d03c4b4ce79e_ZZ3XuX2O',
        createdAt: '2024-01-17T09:15:00Z',
        updatedAt: '2024-01-17T09:15:00Z',
        status: 'inactive',
        boldsignEditUrl: 'https://app.boldsign.com/document/embed/?templateId=516e0ebb-8b0d-4795-85a3-3d03c4b4ce79e_ZZ3XuX2O;1c42ba9b-4a92-4a1c-affd-18414b422f4b&isEditTemplate=true'
    },
    {
        id: '4',
        templateName: 'Pediatric Consent Form',
        description: 'Consent form for pediatric participants',
        documentPath: '/documents/pediatric1.pdf',
        documentUrl: 'https://example.com/pediatric1.pdf',
        formName: 'PED-001',
        formVersion: '1.0',
        boldSignTemplateId: 'template4',
        createdAt: '2024-03-12T14:20:00Z',
        updatedAt: '2024-03-12T14:20:00Z',
        status: 'active',
        boldsignEditUrl: ''
    },
    {
        id: '5',
        templateName: 'Emergency Use Consent',
        description: 'Consent for emergency medical procedures',
        documentPath: '/documents/emergency1.pdf',
        documentUrl: 'https://example.com/emergency1.pdf',
        formName: 'EMER-001',
        formVersion: '1.5',
        boldSignTemplateId: 'template5',
        createdAt: '2024-03-11T11:45:00Z',
        updatedAt: '2024-03-11T11:45:00Z',
        status: 'inactive',
        boldsignEditUrl: ''
    }
]; 